import React from 'react';

import { ADMIN_DASHBOARD, ADMIN_PENDING_HIRES } from '@ApplicationWide/permissions/constants';
import { ATS_ONBOARD_PATH } from '@ApplicationWide/routes/admin/admin-urls';

const AddNewHirePage = React.lazy(() => import('../../../pages/Admin/PendingHires/Onboarding/AddNewHirePage'));

export default {
  route: [ATS_ONBOARD_PATH, `${ATS_ONBOARD_PATH}/:pendingHireId`],
  area: ADMIN_PENDING_HIRES,
  component: AddNewHirePage,
  extraProps: { atsOnboard: true },
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_DASHBOARD,
  hasNavBar: true,
};
